<template>
    <v-container max-width="1200">
        <v-card class="pa-4 align-center justify-center">
            <v-card-title>Sign Up</v-card-title>

            <v-card-text>
                <v-text-field
                    v-model="email"
                    placeholder="Enter your email address"
                    prepend-inner-icon="mdi-email-outline"
                    variant="outlined"
                    :rules="emailRules"
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    :append-inner-icon="passVisible ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="passVisible ? 'text' : 'password'"
                    placeholder="Enter your password"
                    prepend-inner-icon="mdi-lock-outline"
                    variant="outlined"
                    @click:append-inner="passVisible = !passVisible"
                    :rules="passwordRules"
                ></v-text-field>
                <v-text-field
                    v-model="passwordConfirmation"
                    :append-inner-icon="passVisible ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="passVisible ? 'text' : 'password'"
                    placeholder="Confirm your password"
                    prepend-inner-icon="mdi-lock-outline"
                    variant="outlined"
                    @click:append-inner="passVisible = !passVisible"
                    :rules="passwordRules"
                ></v-text-field>
                <v-btn
                    size="large"
                    variant="tonal"
                    block
                    @click="signUp"
                    class="mb-4"
                    :loading="loading"
                >
                    Sign Up
                </v-btn>
                <v-btn
                    size="large"
                    variant="tonal"
                    block
                    @click="toLoginPage"
                >
                    Already have an account? Log In
                </v-btn>
                <v-card-text v-if="errorMessage != ''">{{ errorMessage }}</v-card-text>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
// import axios from 'axios'
// import { VDateInput } from 'vuetify/labs/VDateInput'
// import JsonCSV from 'vue-json-csv'
import { useMainStore } from '@/store/store';
// const store = mainStore();

export default {
    setup() {
        const store = useMainStore()

        return { store }
    },
    name: 'SignUpPage',

    components: {
        // VDateInput,
        // JsonCSV,
    },

    data: () => ({
        email: '',
        password: '',
        passwordConfirmation: '',
        passVisible: false,
        errorMessage: '',
        loading: false,

        emailRules: [
            value => {
                if (value) return true

                return 'E-mail is required.'
            },
            value => {
                if (/.+@.+\..+/.test(value)) return true

                return 'E-mail must be valid.'
            },
        ],
        passwordRules: [
            value => {
                if (value) return true

                return 'Password is required.'
            },
            value => {
                if (value.length > 8) return true

                return 'Password must be over 8 characters'
            },
        ],
    }),

    methods: {
        async signUp() {

            this.loading = true

            if((this.email && this.password && (/.+@.+\..+/.test(this.email))) === false){
                this.errorMessage = "Please enter a valid email and password"
                this.loading = false
                return
            }
            if(this.password !== this.passwordConfirmation){
                this.errorMessage = "Please Ensure that passwords match"
                this.loading = false
                return
            }
            if(this.password.length < 8) {
                this.errorMessage = "Please Ensure that password is over 8 characters"
                this.loading = false
                return
            }

            let user = {
                email: this.email,
                password: this.password
            }
            // console.log("Signing up with data:", user)
            await this.store.signup(user)
                .then(() => {
                    this.loading = false
                    this.$router.push({ path: 'about' })
                    // this.$router.replace({ path: '/' })
                    // this.$router.push({ name: 'admin' })
                })
                .catch((error) => {
                    this.errorMessage = error.response.data
                    this.loading = false
                })
        },
        toLoginPage(){
            this.$router.push({ name: 'login' })
        },

    }

}
</script>
